import React from "react";
import { FILTER_TABS } from "../constants";
import type { DeviceFilter } from "../types";

interface FilterTabsProps {
  activeFilter: DeviceFilter;
  counts: Record<DeviceFilter, number>;
  onFilterChange: (filter: DeviceFilter) => void;
}

const FilterTabs: React.FC<FilterTabsProps> = ({
  activeFilter,
  counts,
  onFilterChange,
}) => (
  <div className="my-devices-tabs">
    {FILTER_TABS.map(({ key, label }) => (
      <button
        key={key}
        type="button"
        className={`my-devices-tab${activeFilter === key ? " active" : ""}`}
        aria-pressed={activeFilter === key}
        onClick={() => onFilterChange(key)}
      >
        <span>{label}</span>
        <strong>{counts[key]}</strong>
      </button>
    ))}
  </div>
);

export default FilterTabs;
